import React, { ReactNode, useEffect, useState } from "react";
type Option = any;

type Props<T> =
  | {
      isMutiple?: true;
      onChange?: (options: T[]) => void; // onChange sẽ nhận vào một mảng các phần tử của T
      defaultValue?: T[];
      dataSource: T[];
      loading?: boolean;
      renderItem: (item: T, state: T[]) => React.ReactNode;
      mode?: "toggle" | "nomal";
    }
  | {
      isMutiple?: false;
      onChange?: (option: T) => void; // onChange sẽ nhận vào một phần tử của T
      dataSource: T[];
      loading?: boolean;
      defaultValue?: T;
      renderItem: (item: T, state: T) => React.ReactNode;
      mode?: "toggle" | "nomal";
      className?: string;
    };

export default function FilterSelect<T>({
  isMutiple = false,
  dataSource,
  defaultValue,
  loading,
  onChange,
  renderItem,
  mode = "toggle",
}: Props<T>) {
  const [selectedItems, setSelectedItems] = useState<any>(
    isMutiple
      ? defaultValue
        ? defaultValue
        : []
      : defaultValue
      ? defaultValue
      : null
  );

  // const [firstRender, setFirstRender] = useState(true)
  function handlerChange(item: Option) {
    let res: any = null;

    if (isMutiple) {
      const selectedIndex = selectedItems.findIndex(
        (selectedItem: any) => selectedItem === item
      );
      const isNotSelected = selectedIndex === -1;
      if (isNotSelected) {
        // Nếu item chưa được chọn thì thêm vào mảng selectedItems
        res = [...selectedItems, item];
      } else if (mode === "toggle") {
        // Nếu item đã được chọn thì loại bỏ khỏi mảng selectedItems

        const updatedItems = [...selectedItems];
        updatedItems.splice(selectedIndex, 1);

        res = updatedItems;
      }
    } else {
      const isNotSelectedSingle = selectedItems ? selectedItems !== item : true;
      if (isNotSelectedSingle) {
        res = item;
      } else if (mode === "toggle") {
        res = null;
      }
    }

    setSelectedItems(res);
    onChange?.(res);
  }

  // useEffect(() => {
  //   if (firstRender) {
  //     setFirstRender(false)
  //     return
  //   }

  // }, [selectedItems])

  useEffect(() => {
    setSelectedItems(defaultValue);
  }, [defaultValue]);

  return (
    <>
      {dataSource.map((item, index) => (
        <div
          key={index}
          onClick={() => handlerChange(item)}
          className="cursor-pointer"
        >
          {renderItem(item, selectedItems)}
        </div>
      ))}
    </>
  );
}
